module.exports = __webpack_public_path__ + "static/media/regionGLP_2022.7f9955ae.png";